import _taggedTemplateLiteral from "/home/bamboo/bamboo-agent-home/xml-data/build-dir/UDFGE-ESHOP4-JOB1/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral.js";
var _templateObject, _templateObject2;
import { jsx } from 'react/jsx-runtime';
import styled, { css } from 'styled-components';
const SCUnorderedList = styled.ul(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n  text-align: left;\n  margin-left: ", ";\n  padding-left: 0;\n  margin-bottom: 0;\n  list-style-type: ", ";\n  ", ";\n"])), props => props.noPadding ? 0 : "20px", props => props.showBullets ? "circle" : "none", props => props.isInline && css(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n      flex-direction: row;\n      flex-wrap: wrap;\n      list-style-type: none;\n      margin: 0;\n      padding: 0;\n    "]))));
const List = props => {
  if (props.isOrdered) {
    return /* @__PURE__ */jsx("ol", {
      style: props.cssObject,
      children: props.children
    });
  } else {
    return /* @__PURE__ */jsx(SCUnorderedList, {
      isInline: props.isInline,
      showBullets: props.showBullets,
      cssObject: props.cssObject,
      noPadding: props.noPadding,
      children: props.children
    });
  }
};
export { List as default };